export const baseRest = 'https://nossomundoazul.com.br/api/artigos/topicos-ajuda/';
